import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink, Hash, PlusCircle, Search, Users } from 'react-feather';

import * as routes from '../../constants/UiRoutes';
import * as constants from '../../constants/AppConstants';

import User from '../User/UserContainer';
import MobileMenuToggle from '../MobileMenuToggle/MobileMenuToggleContainer';
import PropTypes from 'prop-types';

const groupStats = (numChannels, numUsers) => (
  <Fragment>
    {parseInt(numChannels, 10) !== 0 && <strong>{numChannels}&nbsp;{constants.PUBLIC_CHANNELS}</strong>}
    {parseInt(numChannels, 10) !== 0 && parseInt(numUsers, 10) !== 0 && <Fragment> and </Fragment>}
    {parseInt(numUsers, 10) !== 0 && <strong>{numUsers}&nbsp;{constants.USERS}</strong>}
  </Fragment>
);

const IntroContent = (props) => {
  const introContent = [
    {
      itemIcon:   <Hash size={42} />,
      heading:    constants.CHANNELS,
      linkIcon:   <PlusCircle size={18} />,
      linkText:   constants.CREATE_CHANNEL,
      linkRoute:  routes.CREATE_CHANNEL_URL,
      content:    constants.INTRO_CHANNELS,
    },
    {
      itemIcon:   <Users size={42} />,
      heading:    constants.DIRECT_MESSAGES,
      linkIcon:   <PlusCircle size={18} />,
      linkText:   constants.CREATE_DM,
      linkRoute:  routes.CREATE_DM_URL,
      content:    constants.INTRO_DM,
    },
    {
      itemIcon:   <Search size={42} />,
      heading:    constants.DIRECTORY,
      linkIcon:   <Search size={18} />,
      linkText:   constants.BROWSE_DIRECTORY,
      linkRoute:  routes.BROWSE,
      content:    constants.INTRO_DIRECTORY(groupStats(props.numPublicChannels, props.numUsers)),
    },
  ];

  return (
    introContent.map(item =>
      <div className="intro-item" key={item.heading}>
        {item.itemIcon}
        <div className="intro-content">
          <h2>
            <span>{item.heading}</span>
            <Link to={item.linkRoute} className="action-item">
              {item.linkIcon}
              <span>{item.linkText}</span>
            </Link>
          </h2>
          <p>{item.content}</p>
        </div>
      </div>
    )
  );
};

IntroContent.propTypes = {
  numPublicChannels: PropTypes.number,
  numUsers: PropTypes.number,
};

const LandingScreen = (props) => {
  const updoxHelpPageUrl = '/communicating-on-the-go-with-updox-messenger';

  return (
    <div className="landing-container" data-qa="landingScreen">
      <div className="landing-menu">
        <MobileMenuToggle showLabel fullWidth />
      </div>
      <div className="landing-content">
        <div className="landing-header">
          {props.currentUserId &&
            <h1>
              {constants.GREETING}
              <User
                className="name"
                id={props.currentUserId}
                hideAvatar
                hideCurrentUserIndicator
                hideMentionName
                hideStatus
                noPad
              />
            </h1>
          }
          <p>{constants.INTRO_SUBHEADING}</p>
        </div>
        <div className="introduction">
          <IntroContent
            numPublicChannels={props.numPublicChannels}
            numUsers={props.numUsers}
          />
        </div>
        <div className="featured">
          <h3>
            <span>{constants.FEATURES_HEADING}</span>
            <a
              href={`${routes.UPDOX_HELP}${updoxHelpPageUrl}`}
              target="_blank"
              rel="noopener noreferrer"
              className="action-item"
            >
              {constants.UPDOX_HELP_CTA}
            </a>
          </h3>
          <div className="feature">
            <h3>{constants.FEATURE_SEND_TO_INBOX_HEADING}</h3>
            <p>{constants.FEATURE_SEND_TO_INBOX_CONTENT_1}
              <span className="app-icon"><ExternalLink size={20}/></span> {constants.FEATURE_SEND_TO_INBOX_CONTENT_2}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

LandingScreen.propTypes = {
  currentUserId: PropTypes.number,
  numPublicChannels: PropTypes.number,
  numUsers: PropTypes.number,
};

export default LandingScreen;
